import React, { useEffect, useState } from 'react';
import api from '../api';
import { FreigabeAnzeige, formatiereZeit } from '../types';
import './LoginPage.css';

interface FreigabePageProps {
  token: string;
}

const FreigabePage: React.FC<FreigabePageProps> = ({ token }) => {
  const [anzeige, setAnzeige] = useState<FreigabeAnzeige | null>(null);
  const [fehler, setFehler] = useState('');
  const [laden, setLaden] = useState(true);
  const [ok, setOk] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api
      .get<FreigabeAnzeige>(`/api/freigabe/${token}`)
      .then(res => setAnzeige(res.data))
      .catch(err => setFehler(err.response?.data?.detail || 'Freigabe-Link ungültig.'))
      .finally(() => setLaden(false));
  }, [token]);

  const abgelaufen = anzeige ? new Date(anzeige.ablauf).getTime() < Date.now() : false;
  const schonBestaetigt = anzeige?.bereits_bestaetigt || false;

  const bestaetigen = async () => {
    setBusy(true);
    setFehler('');
    try {
      await api.post(`/api/freigabe/${token}/bestaetigen`);
      setOk(true);
    } catch (err: any) {
      setFehler(err.response?.data?.detail || 'Freigabe fehlgeschlagen.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-inner">
        <div className="login-frame">
          <span className="k-corner k-corner--tl">{'// fleet / freigabe'}</span>
          <span className="k-corner k-corner--tr">rollout</span>
          <h1 className="login-h1">Rollout <em>freigeben</em></h1>

          {laden && <div className="k-hinweis">Lädt …</div>}
          {!laden && !anzeige && <div className="k-fehler">{fehler || 'Freigabe-Link ungültig.'}</div>}

          {anzeige && (
            <>
              <dl className="k-fakten">
                <div className="k-fakt">
                  <dt>Image-Tag</dt>
                  <dd className="k-mono">{anzeige.image_tag || '—'}</dd>
                </div>
                <div className="k-fakt">
                  <dt>Instanzen</dt>
                  <dd className="k-mono">{anzeige.ziel_slugs.join(', ')}</dd>
                </div>
                <div className="k-fakt">
                  <dt>Gültig bis</dt>
                  <dd className="k-mono">{formatiereZeit(anzeige.ablauf)}</dd>
                </div>
              </dl>

              {ok ? (
                <div className="k-meldung">Freigegeben — der Rollout läuft jetzt.</div>
              ) : schonBestaetigt ? (
                <div className="k-hinweis">Diese Freigabe wurde bereits verwendet.</div>
              ) : abgelaufen ? (
                <div className="k-fehler">Dieser Freigabe-Link ist abgelaufen.</div>
              ) : (
                <>
                  {fehler && <div className="k-fehler">{fehler}</div>}
                  <button className="k-btn" onClick={bestaetigen} disabled={busy}>
                    {busy ? 'Wird freigegeben …' : 'Rollout freigeben'}
                  </button>
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default FreigabePage;
